import { UserCreateOutDto } from 'shared/domain/user/types/outDto';
import { UserInDto, UserWithPermissionsInDto } from '../types/inDto';
import { UserCreateModel } from '../types/model';
import { userWithPermissionsInDtoToModel } from './toModel';

export function userCreateModelToCreateOutDto(
  userCreateModel: UserCreateModel
): UserCreateOutDto {
  return {
    email: userCreateModel.email,
    permissions: userCreateModel.permissions,
  };
}

export function userWithPermissionsInDtoToUserInDto(
  userWithPermissionsInDto: UserWithPermissionsInDto,
  organizationId: string,
  currentProjectId: string
): UserInDto {
  const model = userWithPermissionsInDtoToModel(
    userWithPermissionsInDto,
    organizationId,
    currentProjectId
  );

  return {
    _id: model._id,
    createdAt: model.createdAt,
    modifiedAt: model.modifiedAt,
    email: model.email,
    personalData: model.personalData,
    sites: model.sites,
    processes: model.processes,
    role: model.role,
  };
}
